module.exports = __webpack_public_path__ + "static/media/text-kerning-icon.89e2615a.svg";